module.exports = __webpack_public_path__ + "img/value-1.1d5a4755.png";